import React from "react";
import Topbar from "@/components/Topbar";
import { GraduationCap, PresentationChart } from "@phosphor-icons/react";
import { TrainingVideos } from "@/components/TrainingVideos";

export default function Training() {
  return (
    <div className="flex-1 overflow-y-auto min-h-0" data-testid="training-page">
      <Topbar />
      <div className="max-w-6xl mx-auto p-6 md:p-10">
        <div className="flex items-start gap-4">
          <div className="h-14 w-14 rounded-xl bg-gradient-to-br from-emerald-500 to-indigo-500 flex items-center justify-center shrink-0 shadow-lg">
            <GraduationCap size={28} weight="fill" className="text-white" />
          </div>
          <div>
            <h1 className="font-heading font-bold text-2xl md:text-3xl">Centro de Entrenamiento SDM</h1>
            <p className="text-sm text-muted-foreground mt-1 max-w-2xl">
              Mira cada video completo y aprueba su cuestionario. Descarga el manual de uso de tu rol cuando lo necesites.
            </p>
            <a href="/training-videos/SDM-Concierge-Entrenamiento.pptx" download
              className="inline-flex items-center gap-1.5 mt-3 text-xs font-semibold text-primary hover:underline" data-testid="training-deck-download">
              <PresentationChart size={14} weight="bold" /> Presentación de entrenamiento (PowerPoint)
            </a>
          </div>
        </div>
        <TrainingVideos />
      </div>
    </div>
  );
}
